export const SIGNUP_FORM_ID_TEST = '8c899a22-dcfb-4e1a-9857-311e032b1dfb';
export const SIGNUP_FORM_ID_PROD = '6dc59b49-e855-451f-81b5-5ef2dfa1a3f4';
export const SIGNIN_FORM_ID_TEST = '700f8a1b-dd85-48f5-9153-919df67bff1a';
export const SIGNIN_FORM_ID_PROD = '3ea16e75-a45e-498a-ac18-15dbf6df0c47';
export const PORTAL_ID_TEST = '3295670';
export const PORTAL_ID_PROD = '3004731';
